import React from 'react';
import './crash.scss';
import { FormattedMessage } from 'react-intl';
import { CrashMessage } from './CrashMessage';
import { CrashMessageHeader } from './CrashMessageHeader';
import { CrashMessageContainer } from './CrashMessageContainer';
import { CrashMessageFooter } from './CrashMessageFooter';
import { IncompatibleBrowser } from '../../app/incompatible-browser/IncompatibleBrowser';
import { isClientSide } from '../../utils/ssrUtils';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export class Crash extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(error: Error) {
    console.log(error);
    // We don't report error for incompatible browsers
    if (isClientSide && window.Rollbar && window.browser_support > 0)
      window.Rollbar.critical(error, { source: 'global page' });
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (isClientSide && window.browser_support === 0) {
      return <IncompatibleBrowser />;
    }

    if (this.state.hasError) {
      return (
        <div className="crash">
          <CrashMessageContainer>
            <CrashMessageHeader>
              <FormattedMessage id="components/crash/Crash.tsx/1" />
            </CrashMessageHeader>
            <CrashMessage />
            <CrashMessageFooter />
          </CrashMessageContainer>
        </div>
      );
    }

    return this.props.children;
  }
}
